export * from './InformationText';
